function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useContext, useState, useEffect, useCallback, memo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useCookie } from '@cb/cookie-manager';
import { ActionType, ComponentType, logEvent } from '@cbhq/client-analytics';
import { GlobalFooterContext } from '../context/GlobalFooterContext.js';
import CDSFooterLink from './CDSFooterLink.js';
import MarketingTrackingPreferencesModal from './MarketingTrackingPreferencesModal.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
const i18nKey = 'SharedFooter.linkTitles';
const messages = defineMessages({
  marketingTrackingPreferences: {
    id: `${i18nKey}.marketingTrackingPreferences`,
    defaultMessage: 'Do Not Share My Personal Information',
    description: `
    #Component: LEGACY
    #CharLimit: 80
    #Context: Button title for opening up marketing preferences modal (CharLimit autocalculated to 80)`
  }
});
const PREFERENCE_EXPIRATION_YEAR = 1;
const expiration = PREFERENCE_EXPIRATION_YEAR * 365;
function getDomainWithoutSubdomain() {
  const hostname = getHostname();
  if (!hostname) {
    return;
  }
  if (hostname === 'localhost') return hostname;
  const _hostname$split = hostname.split('.'),
    _hostname$split2 = _toArray(_hostname$split),
    domain = _hostname$split2.slice(1);
  return `.${domain.join('.')}`;
}
function getHostname() {
  if (typeof window !== 'undefined') {
    return window.location.hostname;
  }
}
const cookieOptions = {
  expires: expiration,
  domain: getDomainWithoutSubdomain(),
  path: '/'
};
function MarketingTrackingPreferences() {
  const _useContext = useContext(GlobalFooterContext),
    IsUserFromAdTrackingOptOutCountries = _useContext.IsUserFromAdTrackingOptOutCountries;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const isAdTrackingCountry = IsUserFromAdTrackingOptOutCountries();
  const _useCookie = useCookie('advertising_sharing_allowed'),
    _useCookie2 = _slicedToArray(_useCookie, 2),
    advertisingSharingEnabledCookie = _useCookie2[0],
    setAdvertisingSharingEnabledCookie = _useCookie2[1];
  const _useState3 = useState(advertisingSharingEnabledCookie?.value),
    _useState4 = _slicedToArray(_useState3, 2),
    marketingTrackingEnabled = _useState4[0],
    setMarketingTrackingEnabled = _useState4[1];
  const advertisingSharingEnabledCookieIsNull = advertisingSharingEnabledCookie === undefined || advertisingSharingEnabledCookie === null || advertisingSharingEnabledCookie.value === null || advertisingSharingEnabledCookie.value === undefined;
  useEffect(() => {
    if (advertisingSharingEnabledCookieIsNull) {
      const value = true;
      setAdvertisingSharingEnabledCookie({
        value
      }, cookieOptions);
      setMarketingTrackingEnabled(value);
    }
  }, [advertisingSharingEnabledCookie]);
  const handleOnPress = useCallback(() => {
    setIsOpen(false);
    setAdvertisingSharingEnabledCookie({
      value: marketingTrackingEnabled,
      updatedAt: Date.now()
    }, cookieOptions);
    const advertisingOptOutAmplitudeEventData = {
      action: ActionType.click,
      componentType: ComponentType.modal
    };
    if (marketingTrackingEnabled) {
      logEvent('advertising_sharing_logged_out_web_toggle_enabled', advertisingOptOutAmplitudeEventData);
    } else {
      logEvent('advertising_sharing_logged_out_web_toggle_disabled', advertisingOptOutAmplitudeEventData);
    }
    window.location.reload();
  }, [setAdvertisingSharingEnabledCookie, marketingTrackingEnabled]);
  const handleOnClose = useCallback(() => {
    setMarketingTrackingEnabled(advertisingSharingEnabledCookie?.value);
    setIsOpen(false);
  }, [advertisingSharingEnabledCookie?.value]);
  const handleOnPress1 = useCallback(() => setIsOpen(open => !open), []);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [isOpen && /*#__PURE__*/jsx(MarketingTrackingPreferencesModal, {
      close: handleOnClose,
      onPress: handleOnPress,
      isToggled: marketingTrackingEnabled,
      setIsToggled: setMarketingTrackingEnabled
    }), isAdTrackingCountry ? /*#__PURE__*/jsx(CDSFooterLink, {
      style: {
        textAlign: 'left'
      },
      onPress: handleOnPress1,
      accessibilityLabel: formatMessage(messages.marketingTrackingPreferences),
      href: "#",
      children: formatMessage(messages.marketingTrackingPreferences)
    }) : null]
  });
}
const MarketingTrackingPreferences$1 = /*#__PURE__*/memo(MarketingTrackingPreferences);
export { MarketingTrackingPreferences$1 as default };
//# sourceMappingURL=MarketingTrackingPreferences.js.map
